import { createSlice, SerializedError } from "@reduxjs/toolkit";
import { LoadingState } from "http/model";
import { getHorseData } from "appredux/actions/horseActions";
import { IHorse } from "appredux/model/horses";

export interface IHorseProfileState {
  status: LoadingState;
  error: null | SerializedError;
  microchip: string;
  horse: IHorse;
}

const PROFILE_INITIAL_STATE: IHorseProfileState = {
  status: LoadingState.initial,
  error: null,
  microchip: null,
  horse: null,
};

const profileSlice = createSlice({
  name: "horseProfile",
  initialState: PROFILE_INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    // getAppData
    builder.addCase(getHorseData.pending, (state: IHorseProfileState) => {
      state.status = LoadingState.loading;
    });
    builder.addCase(getHorseData.fulfilled, (state: IHorseProfileState, action) => {
      state.microchip = action.payload.microchip;
      state.horse = action.payload.horse;
      state.status = LoadingState.loaded;
    });
    builder.addCase(getHorseData.rejected, (state: IHorseProfileState, action) => {
      state.status = LoadingState.failed;
      state.error = action.error;
    });
  },
});

export default profileSlice.reducer;
